import { render, staticRenderFns } from "./MainJurado.vue?vue&type=template&id=c82229f6&"
import script from "./MainJurado.vue?vue&type=script&lang=js&"
export * from "./MainJurado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports